<template>
  <div class="payment-cancelled-container">
    <div class="cancelled-card">
      <!-- <img
        src="/assets/ic_failed.svg"
        alt="Payment Cancelled"
        class="cancelled-icon"
      /> -->
      <h2 class="cancelled-title">Virtual Account Cancelled</h2>
      <p class="cancelled-subtitle">
        The payment via Virtual Account has <b>been cancelled</b>.<br />
        If you have already made a transfer, your funds will be automatically credited to your account balance.
      </p>

      <div class="transaction-details">
        <div class="detail-row">
          <span class="detail-label">Batch ID</span>
          <span class="detail-value">{{ batchId }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Total Transaction</span>
          <span class="detail-value"
            >IDR {{ formatCurrency(totalAmount) }}</span
          >
        </div>
      </div>

      <a
        href="`/transaction/${batchId}`"
        @click.prevent="seeDetails"
        class="see-details-link"
        >View Transaction Details</a
      >

      <button @click="handleOk" class="ok-button">OK</button>
    </div>
    <div class="footer-text text-center">
      <p>
        &copy; PT Anugrah Multi Remittance {{ new Date().getFullYear() }}
        <span class="footer-separator">|</span>
        <a href="#">Term & Conditions</a>
        <span class="footer-separator">|</span> <a href="#">Privacy Policy</a>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";

const router = useRouter();
const route = useRoute();

const store = useStore();

store.state.hideConfigButton = false;
store.state.showTransferNavbar = true;
store.state.showNavbar = false;
store.state.showSidenav = false;
store.state.showFooter = false;

const batchId = ref(null);
const totalAmount = ref(0);

const formatCurrency = (value) => {
  if (value === null || value === undefined) return "0";
  return Number(value).toLocaleString("id-ID", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

onMounted(() => {
  const state = history.state;
  if (state) {
    batchId.value = state.batchId || "N/A";
    totalAmount.value = state.totalAmount || 0;
  }
  if (!batchId.value && route.query.batchId)
    batchId.value = route.query.batchId;
  if (totalAmount.value === 0 && route.query.totalAmount)
    totalAmount.value = parseFloat(route.query.totalAmount);
});

const seeDetails = () => {
  if (batchId.value && batchId.value !== "N/A") {
    router.push({ name: "TransactionDetail", params: { id: batchId.value } });
  } else {
    router.push({ name: "TransactionHistory" });
  }
};

const handleOk = () => {
  router.push({ name: "Transfer" });
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap");

.payment-cancelled-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #fff5f5; /* Light red background */
  padding: 20px;
  font-family: "Inter", sans-serif;
}

.cancelled-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
  padding: 40px;
  text-align: center;
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cancelled-icon {
  width: 100px;
  height: 100px;
  margin-bottom: 24px;
}

.cancelled-title {
  font-size: 24px;
  font-weight: 700;
  color: #c53030; /* Red */
  margin-bottom: 8px;
}

.cancelled-subtitle {
  font-size: 16px;
  color: #c53030;
  margin-bottom: 32px;
}

.transaction-details {
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  font-size: 16px;
}

.detail-row:not(:last-child) {
  border-bottom: 1px solid #e2e8f0;
}

.detail-label {
  color: #4a5568;
}

.detail-value {
  color: #1a202c;
  font-weight: 600;
}

.see-details-link {
  font-size: 16px;
  color: #3182ce;
  text-decoration: none;
  margin-bottom: 32px;
  font-weight: 500;
}

.see-details-link:hover {
  text-decoration: underline;
}

.ok-button {
  background-color: #c53030; /* Red */
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  height: 48px;
  transition: background-color 0.2s;
}

.ok-button:hover {
  background-color: #9b2c2c;
}

.footer-text {
  font-size: 12px;
  color: #a0aec0;
  padding-top: 40px;
  padding-bottom: 20px;
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.footer-text a {
  color: #a0aec0;
  text-decoration: none;
}

.footer-text a:hover {
  text-decoration: underline;
  color: #718096;
}

.footer-separator {
  margin: 0 5px;
}

.payment-cancelled-container {
  position: relative;
  padding-bottom: 80px;
}
</style> 